"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const one_1 = require("remax/one");
const one_2 = require("../one");
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('switch');
const Switch = (props) => {
    const { checked, disabled, small, onChange } = props;
    const handleChange = () => {
        if (disabled) {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
    };
    return (React.createElement(one_1.View, { className: prefixCls, onTap: handleChange },
        React.createElement(one_2.Checkbox, { className: classnames_1.default({
                [`${prefixCls}-default`]: true,
                [`${prefixCls}-checked`]: !small && checked,
                [`${prefixCls}-checked-small`]: small && checked,
                [`${prefixCls}-disabled`]: disabled,
            }), 
            // onChange={handleChange}
            value: checked ? 'on' : 'off', checked: checked }),
        React.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-checkbox`, {
                [`${prefixCls}-checkbox-small`]: small,
                [`${prefixCls}-checkbox-disabled`]: disabled,
            }) })));
};
exports.default = Switch;
